import { SUPPORTED_LANGUAGES } from '@/lib/constants'

export type LanguageCode = typeof SUPPORTED_LANGUAGES[number]['code']

/**
 * @param value - Any candidate locale, e.g. a cookie or a saved profile value.
 * @returns Whether the app ships translations for it.
 */
export const isSupportedLanguage = (value: unknown): value is LanguageCode => (
  SUPPORTED_LANGUAGES.some(language => language.code === value)
)

/**
 * @param profile - A stored or fetched user profile.
 * @returns The user's saved language, or undefined when they never chose one.
 */
export const getProfileLocale = (profile?: { language?: string | null } | null): LanguageCode | undefined => {
  const language = profile?.language
  return isSupportedLanguage(language) ? language : undefined
}
